import React from "react";
import { Box, TextField } from "@mui/material";
import { CallingCodeSelect } from "./country-code-select";
import { splitPhoneNumber } from "./country-codes";

// "+971501234567" -> { countryCode: "+971", phoneNo: "501234567" }; numbers without "+" default to India
export const parsePhoneNumber = (raw) => {
  const s = String(raw || "").trim();
  if (s.startsWith("+")) {
    const { countryCode, phone } = splitPhoneNumber(s);
    if (countryCode) return { countryCode: `+${countryCode}`, phoneNo: phone };
  }
  return { countryCode: "+91", phoneNo: s };
};

const PhoneInput = ({
  countryCode,
  phoneNo,
  onCountryCodeChange,
  onPhoneNoChange,
  label = "Phone Number",
  required = false,
  fullWidth = false,
  error = false,
  helperText = "",
}) => (
  <Box display="flex" gap={1} sx={{ width: fullWidth ? "100%" : undefined }}>
    <CallingCodeSelect
      value={countryCode}
      onChange={(code) => onCountryCodeChange(`+${code}`)}
      sx={{ width: 200, flexShrink: 0 }}
    />
    <TextField
      label={label}
      value={phoneNo}
      onChange={(e) => onPhoneNoChange(e.target.value)}
      required={required}
      error={error}
      helperText={helperText}
      sx={{ flex: 1 }}
    />
  </Box>
);

export default PhoneInput;
